import { Alert, Box, Chip, Container, MenuItem } from '@hopskipdrive/react-components';
import styled from 'styled-components';

import { colorTokens } from '../../../../shared/components/variables';

export const NoDriverVehicleContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
`;

export const Header = styled(Container)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 0;
`;

export const InfoSection = styled(Box)`
  padding-bottom: 8px;
  border-bottom: 1px solid ${colorTokens.border.main};
  width: 100%;
`;

export const StyledChip = styled(Chip)`
  border-radius: 4px;
  padding: 6px 2px;
  min-height: 27px;
  background: ${colorTokens.primary.light};
  color: ${colorTokens.text.contrast};
`;

export const StyledAlert = styled(Alert)`
  display: flex;
  align-items: center;
  padding: 2px 16px;
  width: 100%;

  .MuiAlertTitle-root {
    margin: 0;
  }
`;

export const DriverSearchResultListItem = styled(MenuItem)`
  display: flex;
  padding: 6px 16px;
  align-items: center;
  gap: 6px;
  align-self: stretch;
  color: ${colorTokens.text.secondary};
`;
